import type { Object3D } from 'three'
import { USDZExporter } from 'three/addons/exporters/USDZExporter.js'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

const loader = new GLTFLoader()

export async function loadModel(path: string) {
  const gltf = await loader.loadAsync(path)

  return gltf.scene
}

export async function openIOSARQuickLook(model: Object3D) {
  const exporter = new USDZExporter()
  let arraybuffer

  try {
    arraybuffer = await exporter.parseAsync(model, {
      ar: {
        anchoring: {
          type: 'plane',
        },
        planeAnchoring: {
          alignment: 'horizontal',
        },
      },
    })
  } catch (e) {
    console.error('Error exporting USDZ:', e)
  }

  const blob = new Blob(arraybuffer ? [arraybuffer] : [], {
    type: 'model/vnd.usdz+zip',
  })

  const url = URL.createObjectURL(blob)

  const modelUrl = new URL(url, self.location.toString())

  const anchor = document.createElement('a')
  anchor.setAttribute('rel', 'ar')
  const img = document.createElement('img')
  anchor.appendChild(img)
  anchor.setAttribute('href', modelUrl.toString())
  anchor.style.display = 'none'
  anchor.click()
}

export async function openSceneViewerStatic(modelPath: string) {
  const location = self.location.toString()
  const locationUrl = new URL(location)
  const modelUrl = new URL(modelPath!, location)
  if (modelUrl.hash) modelUrl.hash = ''
  const params = new URLSearchParams(modelUrl.search)

  params.set('mode', 'ar_preferred')
  if (!params.has('disable_occlusion')) {
    params.set('disable_occlusion', 'true')
  }

  const intent = `intent://arvr.google.com/scene-viewer/1.2?${
    params.toString() + '&file=' + encodeURIComponent(modelUrl.toString())
  }#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
    locationUrl.toString()
  )};end;`

  const anchor = document.createElement('a')
  anchor.setAttribute('href', intent)
  console.log('Attempting to present in AR with Scene Viewer...')
  anchor.click()
}

export async function openSceneViewerDynamic(model: Object3D) {
  // If a Three.js model is provided, export it to GLB and create a Blob URL

  const { GLTFExporter } = await import(
    'three/examples/jsm/exporters/GLTFExporter.js'
  )
  const exporter = new GLTFExporter()
  const glbBuffer: ArrayBuffer = await new Promise((resolve) => {
    exporter.parse(
      model,
      (result) => {
        if (result instanceof ArrayBuffer) resolve(result)
      },
      () => {},
      { binary: true }
    )
  })
  const blob = new Blob([glbBuffer], { type: 'model/gltf-binary' })

  const formData = new FormData()
  formData.append('blob', blob, 'model.glb')

  const modelUrlString = await $fetch('/api/upload/model', {
    method: 'POST',
    body: formData,
  })

  const location = self.location.toString()
  const locationUrl = new URL(location)
  const modelUrl = new URL(modelUrlString, location)
  if (modelUrl.hash) modelUrl.hash = ''
  const params = new URLSearchParams(modelUrl.search)

  params.set('mode', 'ar_preferred')
  if (!params.has('disable_occlusion')) {
    params.set('disable_occlusion', 'false')
  }

  // Compose intent URL for Scene Viewer
  const intentUrl = `intent://arvr.google.com/scene-viewer/1.2?${
    params.toString() + '&file=' + encodeURIComponent(modelUrl.toString())
  }#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
    locationUrl.toString()
  )};end;`

  // Open Scene Viewer
  window.location.href = intentUrl
}
